import axios from 'axios'
import brand from '@/brand'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || brand.apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
  timeout: 10000,
})

apiClient.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem('auth_token')
    if (!token) {
      token = sessionStorage.getItem('auth_token')
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      if (localStorage.getItem('session_id')) {
        localStorage.removeItem('session_id')
      }
    }

    if (!token) {
      let sessionId = localStorage.getItem('session_id')
      if (!sessionId) {
        sessionId = 'guest_' + Math.random().toString(36).substr(2, 11) + '_' + Date.now()
        localStorage.setItem('session_id', sessionId)
      }
      config.headers['X-Session-ID'] = sessionId
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      localStorage.removeItem('remember_me')
      sessionStorage.removeItem('auth_token')
      sessionStorage.removeItem('user')
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login'
      }
    }

    if (error.response?.status === 422) {
      const validationErrors = error.response.data.errors
      console.error('Validation errors:', validationErrors)
    }

    return Promise.reject(error)
  }
)

export default apiClient
